<div class="wa-split">
  <div class="wa-cluster">
    <div class="wa-cluster wa-heading-l" (click)="goHome()">
      <wa-icon variant="solid" name="diagram-venn"></wa-icon>
      <span>ExamAlloc</span>
    </div>
    @if (user && user.isAdmin && survey && !atHome()) {
      <wa-breadcrumb>
        <wa-breadcrumb-item (click)="goHome()">
          <wa-icon slot="start" name="house"></wa-icon>
          Home
        </wa-breadcrumb-item>
        <wa-breadcrumb-item>
          {{ survey.name }}
        </wa-breadcrumb-item>
      </wa-breadcrumb>
    }
  </div>
  <div class="wa-gap-l wa-align-items-center">
    @if (!!user) {
      <span class="wa-heading-m">
      {{ getUserFullName() }}
    </span>
    } @else {
      <div class="wa-cluster">
        <span>Click here to log in</span>
        <wa-icon variant="solid" name="arrow-right"></wa-icon>
      </div>
    }
    <wa-dropdown>
      <wa-button slot="trigger" variant="neutral" appearance="filled" withCaret>
        <wa-icon name="user"></wa-icon>
      </wa-button>
        @if (!user) {
          <wa-dropdown-item value="tum-login" (click)="shibboleth_login()">
            <wa-icon name="building-columns"></wa-icon>
            TUM Login
          </wa-dropdown-item>
          <wa-dropdown-item value="guest-login" (click)="guest_login()">
            <wa-icon slot="icon" name="right-to-bracket"></wa-icon>
            Guest Login
          </wa-dropdown-item>
        } @else {
          <wa-dropdown-item value="log-out" (click)="logout()">
            <wa-icon slot="icon" name="right-from-bracket"></wa-icon>
            Log Out
          </wa-dropdown-item>
          <wa-dropdown-item value="home" (click)="goHome()">
            <wa-icon slot="icon" name="house"></wa-icon>
            Home
          </wa-dropdown-item>
        }
        <wa-divider></wa-divider>
        <wa-dropdown-item value="imprint" (click)="goToImprintView()">
          <wa-icon name="section"></wa-icon>
          Imprint
        </wa-dropdown-item>
        <wa-dropdown-item value="privacy-statement" (click)="goToPrivacyView()">
          <wa-icon name="shield-halved"></wa-icon>
          Privacy Statement
        </wa-dropdown-item>
    </wa-dropdown>
  </div>
</div>
